/**
 * Interface for error page state passed via router navigation.
 * 
 * Usage:
 * ```typescript
 * router.navigate(['/error'], {
 *   state: {
 *     title: 'Failed to load opportunity',
 *     message: 'The opportunity could not be loaded.',
 *     backRoute: ['/Opportunities'],
 *     backLabel: 'Back to Opportunities'
 *   } as ErrorPageState
 * });
 * ```
 */
export interface ErrorPageState {
  /** Error title displayed as heading. Default: 'Something went wrong' */
  title?: string;

  /** Error message displayed below the heading. Default: 'An unexpected error occurred. Please try again.' */
  message?: string;

  /** 
   * Route to navigate to when back button is clicked. 
   * If not provided, will use browser back navigation (previous page).
   */
  backRoute?: string[];

  /** Label for the back button. Default: 'Go Back' */
  backLabel?: string;
}

/** Default values for error page state */
export const DEFAULT_ERROR_PAGE_STATE: Partial<ErrorPageState> = {
  title: 'Something went wrong',
  message: 'An unexpected error occurred. Please try again.',
  backLabel: 'Go Back'
};

